import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Administration } from '../../../model/api/administration/administration';
import { GenericHttpService } from '../generic.http.service';
// import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class AdministrationHttpService extends GenericHttpService<Administration, number> {
    constructor(public http: HttpClient) {
        super(http, '', 'administrations');
    }
}
